import {
  tracker,
  trackingEvents,
} from "src/instrumentation/customTrackingEvents";
import { useAuthoringContext } from "src/router/routerContextHooks";

export const useTrackCanvasSearch = () => {
  "use memo";
  const { orgId, flow, version } = useAuthoringContext();

  const baseProps = {
    organization_id: orgId,
    flow_id: flow.id,
    flow_version_id: version.id,
  } as const;

  const trackQuery = (searchTerm: string, resultCount: number) => {
    tracker.emit(
      trackingEvents.canvasSearch({
        ...baseProps,
        search_term: searchTerm,
        action: "query",
        result_count: resultCount,
      }),
    );
  };

  const trackNavigate = (
    direction: "next" | "previous",
    searchTerm: string,
    resultCount: number,
  ) => {
    tracker.emit(
      trackingEvents.canvasSearch({
        ...baseProps,
        search_term: searchTerm,
        action: direction === "next" ? "nav_next" : "nav_previous",
        result_count: resultCount,
      }),
    );
  };

  const trackOpenOmnibox = (searchTerm: string, resultCount: number) => {
    tracker.emit(
      trackingEvents.canvasSearch({
        ...baseProps,
        action: "open_omnibox",
        search_term: searchTerm,
        result_count: resultCount,
      }),
    );
  };

  const trackOpenShortcut = (searchTerm: string, resultCount: number) => {
    tracker.emit(
      trackingEvents.canvasSearch({
        ...baseProps,
        action: "open_shortcut",
        search_term: searchTerm,
        result_count: resultCount,
      }),
    );
  };

  const trackClose = (searchTerm: string, resultCount: number) => {
    tracker.emit(
      trackingEvents.canvasSearch({
        ...baseProps,
        action: "close",
        search_term: searchTerm,
        result_count: resultCount,
      }),
    );
  };

  return {
    trackQuery,
    trackNavigate,
    trackOpenOmnibox,
    trackOpenShortcut,
    trackClose,
  };
};
